import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getKPIBonusPeople } from 'components/Apis/KPIs';

// Async action to fetch people
export const fetchKPIPeople = createAsyncThunk(
  'filter/fetchKPIPeople',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await getKPIBonusPeople(filters);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.response.message);
    }
  }
);

// Slice for managing people data
const KPIPeopleSlice = createSlice({
  name: 'KPIPeople',
  initialState: {
    KPIPeople: null,          // All fetched people
    loading: false,      // Loading state
    error: null,         // Error state
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchKPIPeople.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchKPIPeople.fulfilled, (state, action) => {
        state.loading = false;
        state.KPIPeople = action.payload.data; // Store the list of people
      })
      .addCase(fetchKPIPeople.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Store error message
      });
  },
});

export default KPIPeopleSlice.reducer;
